import { BookingErrorType, PositionCheckInStatusType } from "@vmosolutions/oc-interfaces";

//styles
import { Theme, Tooltip, useTheme } from "@mui/material";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import ErrorOutlineOutlinedIcon from "@mui/icons-material/ErrorOutlineOutlined";
export interface IErrorStatusCellProps {
  value: PositionCheckInStatusType;
  errorMessage: string;
  style?: any;
}

/**
 * A cell in the check in status table to display
 * @param props - value: success, warning or error errorMessage: the error message that was returned from scan
 */
export const ErrorStatusCell = (props: IErrorStatusCellProps): JSX.Element => {
  const { value, errorMessage } = props;

  const color =
    value === PositionCheckInStatusType.ERROR
      ? "red"
      : value === PositionCheckInStatusType.WARNING
        ? "orange"
        : value === PositionCheckInStatusType.SUCCESS
          ? "green"
          : "black";
  return (
    <div style={{ cursor: "pointer" }}>
      <Tooltip enterDelay={1000} placement="top" title={errorMessage} sx={{ cursor: "pointer" }}>
        <CheckCircleOutlineIcon className="status_icon" style={{ color: color }} />
      </Tooltip>
    </div>
  );
};

/**
 * An icon for a booking error
 * @param props - value: success, warning or error errorMessage: the error message that was returned from scan
 */
export const BookingErrorStatusCell = (props: any): JSX.Element => {
  const { value, errorMessage } = props;
  const theme: Theme = useTheme();
  const color =
    value === BookingErrorType.UNBOOKED_FLIGHT
      ? theme.palette.error.main
      : value === BookingErrorType.BOOKING_PAIRING_MISMATCH
        ? theme.palette.error.main
        : value === BookingErrorType.OVERBOOKED_FLIGHT
          ? theme.palette.error.main
          : "black";
  return (
    <div style={{ cursor: "pointer", display: "flex", alignSelf: "center" }}>
      <Tooltip enterDelay={1000} placement="top" title={value?.toString()} sx={{ cursor: "pointer" }}>
        <ErrorOutlineOutlinedIcon className="status_icon" style={{ color: color }} />
      </Tooltip>
    </div>
  );
};
